// components/templates/sections/EditorialBanner.tsx
'use client';
import React from 'react';
import { useDesign } from '@/context/DesignContext';

interface EditorialBannerProps {
  image?: string;
  quote?: string;
  author?: string;
  design?: any;
}

export default function EditorialBanner({ image, quote, author, design: propDesign }: EditorialBannerProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  if (!image && !quote) return null;

  const primaryColor = design?.colors?.primary || '#C8A96E';
  const textColor = design?.colors?.text || '#F5F5F5';
  const textLightColor = design?.colors?.textLight || '#A3A3A3';
  const headingFont = design?.typography?.headingFont || "'Cormorant Garamond', serif";
  const bodyFont = design?.typography?.bodyFont || "'Inter', sans-serif";

  return (
    <section className="relative overflow-hidden" style={{ height: 500 }}>
      {image && <img src={image} alt="Editorial" className="w-full h-full object-cover" style={{ filter: "brightness(0.35)" }} />}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-8">
        <div className="text-xs uppercase tracking-widest mb-6" style={{ fontFamily: bodyFont, color: primaryColor }}>— The Vertrin Manifesto</div>
        {quote && <h2 className="font-serif text-5xl md:text-7xl font-light max-w-3xl leading-tight" style={{ fontFamily: headingFont, color: textColor }}>"{quote}"</h2>}
        <div className="mt-8 w-24 h-px" style={{ background: primaryColor }} />
        {author && <div className="mt-6 text-xs uppercase tracking-widest" style={{ fontFamily: bodyFont, color: textLightColor }}>{author}</div>}
      </div>
    </section>
  );
}